import gql from 'graphql-tag';

const UpdateRefundFromLawyer = gql`
  mutation UpdateRefundFromLawyer(
    $input: UpdateRefundFromLawyerMutationInput!
  ) {
    updateRefundFromLawyer(input: $input) {
      claim {
        refundFromLawyerAmountForPax
        refundFromLawyerLegalFeesAmount
        refundFromLawyerDate
      }
    }
  }
`;

export { UpdateRefundFromLawyer };



// WEBPACK FOOTER //
// ./src/mutations/UpdateRefundFromLawyer.js